import { render, staticRenderFns } from "./DimensionsSettingsView.vue?vue&type=template&id=04e4fcaa&scoped=true"
import script from "./DimensionsSettingsView.ts?vue&type=script&lang=ts&external"
export * from "./DimensionsSettingsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4fcaa",
  null
  
)

export default component.exports